import detectedPlatform from "./PlatformUtils";
import { toast } from "react-toastify";
import { globalNavigate, clearJwtContext } from "./ConfigContext";

export const isTokenValid = (tokenData) => {
  try {
    const isValid = tokenData.exp * 1000 > Date.now();
    console.log("Token Valid: ", isValid);
    return isValid; // `exp` is in seconds
  } catch (error) {
    console.log("ERROR in verifying token");
    return false;
  }
};

export function invalidateCookie(name) {
  if (document.cookie.includes(name)) {
    deleteCookie(name);
  }
}

function deleteCookie(name) {
  document.cookie = name + "=; max-age=0; path=/;";
}

// Create a standalone utility function
export async function getJwtDataViaAtob(jwt) {
  return jwt ? JSON.parse(atob(jwt.split(".")[1])) : null;
}

export function getJwtData(jwt) {
  if (typeof jwt !== "string") {
    console.warn("Invalid JWT: not a string", jwt);
    return null;
  }

  try {
    const base64Url = jwt.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (err) {
    console.error("Failed to decode JWT:", err);
    return null;
  }
}

// export function logoutWithRedirect(navigate, tenant) {
//   invalidateCookie("token");
//   window.location.href = "/";
//   const platform = detectedPlatform();
//   switch (platform) {
//     case "android":
//       window.ZoomHelper.removeTenantTagForPushNotification(tenant);
//       break;
//     case "ios":
//       window.webkit?.messageHandlers?.deregisterPush?.postMessage({
//         tenant: tenant,
//       });
//       break;
//     default:
//       break;
//   }
// }

export function logoutWithRedirect(navigate, tenant) {
  try {
    // 1️⃣ Invalidate token
    invalidateCookie("token");
    clearJwtContext();

    // 3️⃣ Clean up platform-specific push settings
    const platform = detectedPlatform();
    switch (platform) {
      case "android":
        if (window.ZoomHelper?.removeTenantTagForPushNotification) {
          window.ZoomHelper.removeTenantTagForPushNotification(tenant);
        }
        break;

      case "ios":
        if (window.webkit?.messageHandlers?.deregisterPush) {
          window.webkit.messageHandlers.deregisterPush.postMessage({
            tenant,
          });
        }
        break;

      default:
        break;
    }
    globalNavigate("/");
  } catch (err) {
    console.error("Logout failed:", err);
    toast.error("Something went wrong during logout.", {
      style: { zIndex: 999999 },
    });
  }
}
